<template>
	<dms-col :render-col="true" :sm="1" class="frm-group-item">
		<dms-button :span="1" icon="el-icon-info" class="info-button" :disabled="disabled" :type="type" :data-cy="dataLabel" @click="changeVisibility" />
		<dms-dialog :dialog-mode="pageMode" :visible="showDialog" :hide-cancel="true" @dialog-close="showDialog= false" @ok-clicked="changeVisibility">
			<template slot="title">
				{{ !!titleKey ? localizedTitle : title }}
			</template>
			<div slot="content" class="pre-formatted">
				{{ localizedText }}
			</div>
		</dms-dialog>
	</dms-col>
</template>

<script>
import { sanitize } from '@/main/utils/html-sanitizer';

import { BUTTON_TYPES, BUTTON_TYPES_ENUM } from '#components/@types/button';

import { DmsBaseComponent } from '../common/base';

export default DmsBaseComponent.extend({
	name: 'DmsInfoButton',
	props: {
		disabled: { type: Boolean, default: false },
		textKey: { type: String, default: '' },
		longTextKey: { type: String },
		titleKey: { type: String, default: '' },
		title: { type: String, default: '' },
		text: { type: String, default: '' },
		type: {
			type: String,
			in: BUTTON_TYPES,
			default: BUTTON_TYPES_ENUM.TEXT,
		},
	},
	data() {
		return {
			showDialog: false,
			loadingTextLong: false,
			textLong: null,
		};
	},
	computed: {
		localizedTitle() {
			return this.getText(this.label, this.titleKey, undefined, this.LocalizeTitle);
		},
		localizedText() {
			let { text } = this;
			this.textKey && (text = this.getText(this.label, this.textKey, undefined, this.LocalizePopisostatni));
			this.longTextKey && (text = this.textLong);

			return text;
		},
		dataLabel() {
			return this.longTextKey ? this.longTextKey : this.titleKey;
		},
	},
	methods: {
		async changeVisibility() {
			!this.showDialog && !!this.longTextKey && await this.loadTextLong();
			this.showDialog = !this.showDialog;
		},
		async loadTextLong() {
			this.loadingTextLong = true;
			this.textLong = sanitize(await this.LocalizeTextLong(this.longTextKey));
			this.loadingTextLong = false;
		},
	},
});
</script>

<style lang="scss" scoped>
.info-button {
	font-size: 20px;
	padding: 3px;
	color: $color-info;
}

.pre-formatted {
  white-space: pre-wrap;
}

</style>
